/*
 * Subaccounts
 *
 * Display, update information of SubAccount
 **/
import { MUAPP } from 'account/api';
import { customerRenderHandler } from 'account/customer';
import { submissionSuccessHandler } from 'account/utils';

/**
 * addSubAccount
 * Create subaccount customers in MU app API
 *
 * @param {object} event - Click event object from the form
 */
export const addSubAccount = (event) => {
  event.preventDefault();
  const $form = $(event.target).closest('form');
  const $formWrapper = $('.js-sub-accounts');

  // POST customer data
  const payload = {
    first_name: $form.find("[name='sparssubaccount[first_name]']").val(),
    last_name: $form.find("[name='sparssubaccount[last_name]']").val(),
    email: $form.find("[name='sparssubaccount[email]']").val().toLowerCase(),
  };

  $form.parsley().validate();
  if ($form.parsley().isValid()) {
    MUAPP.subAccounts.addSubAccounts(payload).then((data) => {
      displaySubAccounts(data.new_user);
      submissionSuccessHandler(
        $formWrapper,
        'New Account User is successfully added.',
      );
    });
  } else {
    // All exception handlings
  }
};

/**
 * displaySubAccounts
 *
 * @param {object} customers spars customer data
 */
export const displaySubAccounts = (subAccounts = []) => {
  if (!$('.spars-user')) return;
  const newAccount = !Array.isArray(subAccounts);
  subAccounts = !newAccount
    ? subAccounts.filter((subaccount) => !subaccount.is_admin)
    : [subAccounts];

  if (!newAccount) $('.spars-user__list').html('');
  $('.spars-user__list').append(
    subAccounts.map(function (item) {
      return window.subAccountTemplate.render(item);
    }),
  );
  //$subAccountsContainer.removeClass("hidden");
};



// WEBPACK FOOTER //
// ./src/scripts/src/account/subaccount.js